<template>
    <div>
        <v-card>
            <v-card-text>
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-row>
                            <v-col cols="4">
                                <v-icon>
                                    mdi-account
                                </v-icon>
                                {{ baseData.name }}
                            </v-col>
                            <v-col cols="8">
                                <v-row justify="end" class="mr-1 mt-1">
                                    {{ baseData.createTime }} 2004
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-list-item-subtitle>
                            <v-row class="mt-6">
                                <v-col cols="6">
                                    {{ baseData.phone }}
                                    <v-icon class="ml-4">
                                        mdi-phone
                                    </v-icon>
                                </v-col>
                                <v-col cols="5">
                                    <v-row class="mt-1" justify="end">
                                        <el-link @click="updatePurpose" :underline="false" type="danger">
                                            客户意向：{{ baseData.intention === 0 ? '无意向' : baseData.intention === 1 ? '低意向' : '高意向'}}
                                        </el-link>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-card-text>
        </v-card>
        <v-row class="ml-2">
            <v-col cols="5" class="font-weight-bold" style="font-size: 16px">
                基本资料
            </v-col>
            <v-col cols="6">
                <v-row justify="end">
                    <v-btn color="primary" @click="updateStuMsg" dark small>
                        <v-icon left>mdi-update</v-icon>
                        编辑
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-card
        >
            <v-card-text>
                <div class="text--primary">
                    性别：{{ baseData.gender === 0 ? '男' : '女'}}
                </div>
                <div class="text--primary">
                    学校：{{ baseData.schoolName}}
                </div>
                <div class="text--primary">
                    专业：{{ baseData.specialities}}
                </div>
                <div class="text--primary">
                    微信：{{ baseData.wechat}}
                </div>
                <div class="text--primary">
                    qq：{{ baseData.qq}}
                </div>
                <div class="text--primary">
                    来源：{{ baseData.source == 0 ? '讲座' :
                    baseData.source == 1 ? '老学员推荐' :
                        baseData.source == 2 ? '招聘会' :
                            baseData.source == 3 ? '市场活动' :
                                baseData.source == 4 ? '外包' : '其他' }}
                    {{ baseData.source == 5 ? ' - '+baseData.other :'' }}
                </div>
            </v-card-text>
        </v-card>
        <v-row class="ml-2">
            <v-col cols="5" class="font-weight-bold" style="font-size: 16px">
                线索备注
            </v-col>
            <v-col cols="6">
                <v-row justify="end">
                    <v-btn color="primary" @click="updateRemark" dark small>
                        <v-icon left>mdi-update</v-icon>
                        编辑
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-card
        >
            <v-card-text>
                <div class="text--primary">
                    {{ baseData.remarks }}
                </div>
            </v-card-text>
        </v-card>
        <v-row class="ml-2">
            <v-col cols="5" class="font-weight-bold" style="font-size: 16px">
                跟踪记录
            </v-col>
            <v-col cols="6">
                <v-row justify="end">
                    <v-btn color="primary" @click="addFollow" dark small>
                        <v-icon left>mdi-plus</v-icon>
                        添加跟进
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-card
        >
            <v-card-text v-for="item in followData">
                <v-row>
                    <v-col cols="6">
                        <div style="float:left;width: 2px;height: 20px; background: #000;"></div>
                        <div class="text--primary font-weight-bold ml-2">
                            线索跟进
                        </div>
                    </v-col>
                    <v-col>
                        <v-row justify="end">
                            {{ item.createTime }}
                        </v-row>
                    </v-col>
                </v-row>
                <div class="text--primary">
                    跟进方式：{{ item.type === 1?'电话': item.type === 2?'微信':item.type === 3?'qq':'面访'}}
                </div>
                <div class="text--primary">
                    跟踪记录：{{ item.recored }}
                </div>
                <div class="text--primary">
                    下次跟进时间：{{ item.nextTime }}
                </div>
                <v-divider class="mt-6"></v-divider>
            </v-card-text>
        </v-card>
        <v-row class="ml-2">
            <v-col cols="5" class="font-weight-bold" style="font-size: 16px">
                交费记录
            </v-col>
            <v-col cols="6">
                <v-row justify="end">
                    <v-btn color="primary" @click="addFee" dark small>
                        <v-icon left>mdi-plus</v-icon>
                        添加缴费
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-card
        >
            <v-card-text v-for="item in feeData">
                <v-row>
                    <v-col cols="6">
                        <div style="float:left;width: 2px;height: 20px; background: #000;"></div>
                        <div class="text--primary font-weight-bold ml-2">
                            交费明细
                        </div>
                    </v-col>
                    <v-col>
                        <v-row justify="end">
                            {{ item.createTime }}
                        </v-row>
                    </v-col>
                </v-row>
                <div class="text--primary">
                    交易金额：{{ item.money }}
                </div>
                <div class="text--primary">
                    交费内容：{{ item.content }}
                </div>
                <div class="text--primary">
                    交费方式：{{ item.type == 1?'支付宝':item.type == 2?'微信':item.type == 3?'银行卡':'贷款' }}
                </div>
                <v-divider class="mt-6"></v-divider>
            </v-card-text>
        </v-card>
        <v-btn v-if="baseData.auditState === 0" class="mt-10 mb-6" width="94vw" color="success" dark @click="oaProcessTuition">
            {{ $vuetify.lang.t('$vuetify.custom.market.feeAlreadyFull') }}
        </v-btn>
        <v-btn v-else-if="baseData.auditState === 1" class="mt-10 mb-6" width="94vw" color="success" dark>
            待审核
        </v-btn>
        <v-btn v-else-if="baseData.auditState === 2" class="mt-10 mb-6" width="94vw" color="success" dark>
            已审核
        </v-btn>
        <v-dialog v-model="purposeDialog" max-width="700px">
            <mark-purpose :intentionData="intentionData" @initBaseMsg="initBaseMsg" v-model="purposeDialog"></mark-purpose>
        </v-dialog>
        <v-dialog v-model="remarkDialog" max-width="700px">
            <mark-remark :remarkData="remarkData" @initBaseMsg="initBaseMsg" v-model="remarkDialog"></mark-remark>
        </v-dialog>
        <v-dialog v-model="followDialog" max-width="700px">
            <mark-follow :followId="id" @queryFollow="queryFollow" v-model="followDialog"></mark-follow>
        </v-dialog>
        <v-dialog v-model="feeDialog" max-width="700px">
            <mark-fee v-model="feeDialog" @queryFee="queryFee" :feeId="id"></mark-fee>
        </v-dialog>
    </div>
</template>
<script>

import markPurpose from "./detail-pop/mark-purpose"
import markRemark from "./detail-pop/mark-remark"
import markFollow from "./detail-pop/mark-follow"
import markFee from "./detail-pop/mark-fee"

import * as dd from 'dingtalk-jsapi';
import dialog from "@/components/dialog"; // 此方式为整体加载，也可按需进行加载
export default {
    data() {
        return {
            id: '',
            remarkData:{
                clewId:'',
                remarks:'',
            },
            intentionData:{
                clewId:'',
                intention:'',
            },
            baseData:[],
            followData:[],
            feeData:[],
            feeDialog: false,
            followDialog: false,
            remarkDialog: false,
            purposeDialog: false,
            tab: null,
            items: [
                '待跟进', '全部', '三天未跟进', '待审核', '已交齐学费',
            ],
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        }

    },
    watch: {},
    mounted() {
        this.id = this.$route.query.id
        this.initBaseMsg()
        this.queryFollow()
        this.queryFee()
    },
    methods: {
        initBaseMsg() {
            this.$api.clew.queryDetail({"id": this.id}).then(data => {
                if (data.data) {
                    this.baseData = data.data
                }
            })
        },
        queryFollow(){
            this.$api.follow.queryClewFollowRecordByClewId({"id": this.id}).then(data => {
                if (data.data) {
                    this.followData = data.data
                }
            })
        },
        queryFee(){
            this.$api.payRecord.queryPayRecordByClewId({"id": this.id}).then(data => {
                if (data.data) {
                    this.feeData = data.data
                }
            })
        },
        addFee() {
            this.feeDialog = true
        },
        addFollow() {
            this.followDialog = true
        },
        updateRemark() {
            Object.assign(this.remarkData,{
                clewId:this.baseData.id,
                remarks:this.baseData.remarks,
            })
            this.remarkDialog = true
        },
        updatePurpose() {
            Object.assign(this.intentionData,{
                clewId:this.baseData.id,
                intention:this.baseData.intention.toString(),
            })
            this.purposeDialog = true
        },
        updateStuMsg() {
            this.$publish.publish("updateTitle", "编辑线索")
            this.$router.push({
                path: "/marketUpdate",
                query: {
                    id: this.id
                }
            })
        },
        oaProcessTuition(){
            let $this = this;
            this.$api.dingtalk.sign('etoak', {nonceStr:new Date().getTime(), timeStamp:new Date().getTime(), url:location.href}).then(data => {
                let r = data.data;
                dd.config({
                    agentId : r.agentId,
                    corpId : r.corpId,
                    timeStamp : r.timeStamp,
                    nonceStr : r.nonceStr,
                    signature : r.signature,
                    jsApiList : [ 'runtime.info', 'biz.contact.choose',
                        'device.notification.confirm', 'device.notification.alert',
                        'device.notification.prompt', 'biz.ding.post',
                        'biz.util.openLink', 'biz.contact.complexPicker']
                });


                dd.ready(function() {
                    dd.biz.contact.complexPicker({
                        title:"测试标题",            //标题
                        corpId:r.corpId,              //企业的corpId
                        multiple:!1,            //是否多选
                        limitTips:"超出了",          //超过限定人数返回提示
                        maxUsers:1,            //最大可选人数
                        pickedUsers:[],            //已选用户
                        pickedDepartments:[],          //已选部门
                        disabledUsers:["171321074020219"],            //不可选用户
                        disabledDepartments:["402488627"],        //不可选部门
                        requiredUsers:[],            //必选用户（不可取消选中状态）
                        requiredDepartments:[],        //必选部门（不可取消选中状态）
                        appId:r.agentId,              //微应用Id，企业内部应用查看AgentId
                        responseUserOnly:true,        //返回人，或者返回人和部门
                        startWithDepartmentId:0 ,   //仅支持0和-1
                        onSuccess: function(result) {
                            console.log(result)
                            $this.onSelectEmp(result);
                        },
                        onFail : function(err) {
                           //console.error('ddd error: ' h+ JSON.stringify(err))
                            alert('ddd error: ' + JSON.stringify(err));
                        }
                    });


                    dd.error(function(error){
                        alert('dd error: ' + JSON.stringify(error));
                    });
                });
            });
        },
        onSelectEmp(selectEmp){
            this.$api.dingtalk.oaProcessTuition('etoak', {clewId:this.id,dingtalkUserid:selectEmp.users[0].emplId}).then(data => {
                if(data.flag){
                    this.$dialog.alert('提交成功，请等待审批');
                }else{
                    this.$dialog.alert(data.msg || '出现错误，请联系管理');
                }
            })
        }
    },
    components: {
        markPurpose,
        markRemark,
        markFollow,
        markFee,
    }
}
</script>
<style scoped>

</style>
